import { Box } from '@material-ui/core';
import React from 'react';
import { useField } from 'formik';
import { useSelector } from 'react-redux';
import { QuantityType } from 'shared/models/sheet/Sheet';
import { maxDollarsExpenseValue } from 'shared/models/validationSchemes/expenseEntry';
import { IFormFieldProps } from 'shared/components/formFields/models';
import NumberInput from 'shared/components/formFields/NumberInput';
import { formatDollars } from 'shared/utils/formatters/dollarFormatter';
import { selectExpenseReceiptRequiredDollars } from 'store/entities/clients/selectors/configurationSelectors';

export interface IFormMoneyInputProps extends IFormFieldProps {
    showNote?: boolean;
}

const MoneyDataField = ({
    name,
    label,
    id = String(name),
    className,
    disabled = false,
    showNote = false,
}: IFormMoneyInputProps) => {
    const expenseReceiptRequiredDollars = useSelector(selectExpenseReceiptRequiredDollars);
    const [field, meta, helper] = useField(name);

    const handleChange = (value: string) => {
        helper.setValue({
            entry_type: QuantityType.MONEY,
            dollars: value,
        });
    };
    return (
        <>
            <NumberInput
                id={id}
                name={name}
                label={label}
                initialValue={field.value?.dollars}
                className={className}
                inputProps={{
                    decimalScale: 2,
                    thousandSeparator: true,
                    allowNegative: false,
                    fixedDecimalScale: true,
                    isNumericString: true,
                }}
                disabled={disabled}
                error={meta.error}
                touched={meta.touched}
                setTouched={helper.setTouched}
                onChange={handleChange}
                min={0}
                max={maxDollarsExpenseValue}
            />
            {showNote && Boolean(expenseReceiptRequiredDollars) && (
                <Box
                    pt={2}
                    ml={2}
                    display="inline-flex"
                    className={className}
                >
                    *if the amount is over {formatDollars(expenseReceiptRequiredDollars)}, please attach a receipt.
                </Box>
            )}
        </>
    );
};

export default MoneyDataField;
